module.exports = {"buttons":{"next":"Continuar","back":"Voltar"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/BlockIdentifiersForm/data.json
// module id = 1793
// module chunks = 0